import QRCode from 'qrcode'

export type QRType = 'equipment' | 'beds' | 'patient'

export async function generateQRCode(text: string) {
  return QRCode.toDataURL(text)
}

export function getScanUrl(type: QRType, id: string, path?: string) {
  const origin = typeof window !== 'undefined' ? window.location.origin : ''
  const scanPath = path ?? type
  return `${origin}/scan/${scanPath}/${id}`
}

export async function printQRCodes({
  items,
}: {
  items: {
    url: string
    title: string
    subtitle?: string
  }[]
}) {
  const printWindow = window.open('', '_blank')
  if (!printWindow) return

  let html = `<!DOCTYPE html><html><head><title>QR Codes - MedTrack</title><style>
      body { font-family: sans-serif; margin: 0; padding: 20px; }
      .grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 16px; }
      .card { border: 1px solid #ccc; border-radius: 8px; padding: 12px; text-align: center; page-break-inside: avoid; }
      .card img { display: block; margin: 0 auto 8px; }
      .name { font-size: 12px; font-weight: bold; margin-bottom: 4px; }
      .sub { font-family: monospace; font-size: 11px; color: #666; }
      .dept { font-size: 10px; color: #999; margin-top: 4px; }
      @media print { body { padding: 10px; } .grid { gap: 8px; } }
      </style></head><body><div class="grid">`

  for (const item of items) {
    const qr = await generateQRCode(item.url)
    html += `
        <div class="card">
          <div class="qr">
            <img src="${qr}" width="120" height="120" />
          </div>

          <div class="name">${item?.title}</div>
          ${item?.subtitle ? `<div class="sub">${item.subtitle}</div>` : ''}
        </div>
      `
  }

  html += `</div></body></html>`

  printWindow.document.write(html)
  printWindow.document.close()
  printWindow.onload = () => printWindow.print()
}
